import { apiUrl } from "./AxiosHeaders";
import { getApiErrorMessage } from "../../utilis/apiErrorMessage";

const apiManager = {
  get: async (url, params = {}) => {
    try {
      const response = await apiUrl.get(url, { params });
      return handleSuccess(response);
    } catch (error) {
      return handleError(error);
    }
  },

  post: async (url, data) => {
    try {
      const response = await apiUrl.post(url, data);
      return handleSuccess(response);
    } catch (error) {
      return handleError(error);
    }
  },

  put: async (url, data) => {
    try {
      const response = await apiUrl.put(url, data);
      return handleSuccess(response);
    } catch (error) {
      return handleError(error);
    }
  },

  delete: async (url) => {
    try {
      const response = await apiUrl.delete(url);
      return handleSuccess(response);
    } catch (error) {
      return handleError(error);
    }
  },
};

export default apiManager;

function handleSuccess(response) {
  return {
    status: response.status,
    data: response.data,
    success: true,
  };
}

function handleError(error) {
  if (error?.suppressUserMessage) {
    return {
      status: error.response?.status ?? null,
      message: null,
      success: false,
      suppressed: true,
    };
  }

  const message = error?.userMessage || getApiErrorMessage(error);

  if (!message) {
    return {
      status: error.response?.status ?? null,
      message: null,
      success: false,
      suppressed: true,
    };
  }

  if (error.response) {
    return {
      status: error.response.status,
      message,
      data: error.response.data,
      success: false,
    };
  }

  return {
    status: null,
    message,
    success: false,
  };
}
